var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManwithplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 51,
    viewBox: "0 0 64 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 20.7188H56V14.3438C56 13.4672 55.28 12.75 54.4 12.75H51.2C50.32 12.75 49.6 13.4672 49.6 14.3438V20.7188H43.2C42.32 20.7188 41.6 21.4359 41.6 22.3125V25.5C41.6 26.3766 42.32 27.0938 43.2 27.0938H49.6V33.4688C49.6 34.3453 50.32 35.0625 51.2 35.0625H54.4C55.28 35.0625 56 34.3453 56 33.4688V27.0938H62.4C63.28 27.0938 64 26.3766 64 25.5V22.3125C64 21.4359 63.28 20.7188 62.4 20.7188ZM22.4 25.5C29.47 25.5 35.2 19.7924 35.2 12.75C35.2 5.70762 29.47 0 22.4 0C15.33 0 9.6 5.70762 9.6 12.75C9.6 19.7924 15.33 25.5 22.4 25.5ZM31.36 28.6875H29.69C27.47 29.7035 25 30.2812 22.4 30.2812C19.8 30.2812 17.34 29.7035 15.11 28.6875H13.44C6.02 28.6875 0 34.684 0 42.075V46.2188C0 48.8584 2.15 51 4.8 51H40C42.65 51 44.8 48.8584 44.8 46.2188V42.075C44.8 34.684 38.78 28.6875 31.36 28.6875Z",
    fill: "#0A064C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManwithplus);
export default __webpack_public_path__ + "static/media/manwithplus.ffac072b47b892654bef9a3a565b1fe9.svg";
export { ForwardRef as ReactComponent };